import React from "react";
import { getFormattedNumber } from "../utils/textUtils";

// Items that were neither issued, sold nor stock transferred in the selected
// date range (and still hold stock). One row per item per warehouse.
const NonMovingItems = ({ resPacket }) => {
  // Days since the item last moved (issued, sold or transferred), computed by the SP.
  const lastMovement = (a) =>
    a.daysSinceLastMovement === null || a.daysSinceLastMovement === undefined
      ? "No movement ever"
      : a.daysSinceLastMovement + " days";
  const packQty = (a) => Number(a.currentStockPackQuantity || 0);
  const openQty = (a) => Number(a.currentStockOpenQuantity || 0);
  // show only the non-zero parts: "12 Kg", "500 Gm" or "12 Kg + 500 Gm"
  const showStock = (a) => {
    const parts = [];
    if (packQty(a)) parts.push(getFormattedNumber(packQty(a)) + " " + (a.packUnitTitle || ""));
    if (openQty(a)) parts.push(getFormattedNumber(openQty(a)) + " " + (a.openUnitTitle || ""));
    return parts.join(" + ");
  };

  // zero stock items are already excluded by the SP; keep a safeguard here too
  const rows = (resPacket || []).filter((a) => packQty(a) > 0 || openQty(a) > 0);

  return rows.length > 0 ? (
    <div className="customTable" id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <th>SNO.</th>
            <th>ITEM</th>
            <th>CATEGORY</th>
            <th>WAREHOUSE</th>
            <th className="text-center">CURRENT STOCK</th>
            <th className="text-center">LAST MOVEMENT</th>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {rows.map((a, i) => (
            <tr key={a.itemUuid + "-" + a.warehouseTitle + "-" + i}>
              <td>{i + 1}</td>
              <td>{a.itemTitle}</td>
              <td>{a.category}</td>
              <td>{a.warehouseTitle}</td>
              <td className="text-center">{showStock(a)}</td>
              <td className="text-center">{lastMovement(a)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <>No Record found</>
  );
};

export default NonMovingItems;
